import OSS from 'ali-oss';
import { getUploadConfig } from '@/api/public';

// 上传类型
const uploadType = [
  { label: 'image', value: 1 },
  { label: 'video', value: 2 }
];

const getUploadOption = (file, type) => {
  return new Promise(async(resolve) => {
    console.log(type, 'type');
    const params = {
      ossFiles: [
        {
          fileName: file.name,
          filePath: '1234',
          hashCode: '1234'
        }
      ],
      type: (uploadType.find((item) => item.label === type) || {}).value || 3
    };
    const data = await getUploadConfig(params); 
    resolve(data);
  });
};

export const uploadFile = (file, type) => {
  return new Promise(async(resolve) => {
    const config = await getUploadOption(file, type);
    const {
      ossPath,
      secretId: accessKeyId,
      secretKey: accessKeySecret,
      sessionToken: stsToken,
      bucketName: bucket,
      regionName: region
    } = config[0];

    const client = new OSS({
      region,
      accessKeyId,
      accessKeySecret,
      stsToken,
      bucket,
      authorizationV4: true, // 从V1签名升级为V4签名
    });
    const result = await client.put(ossPath, file);
    resolve(result);
  });
};
